import type { ContinuationTarget } from "~/helpers/pendingIntentLifecycle";
import type { ReceiverIdentityAdapter } from "~produce/production/helpers/continuationAdapter";

import STOCK_LOT_TARGET_KIND from "~fulfill/inventory/stock/constants/stockLotTargetKind";

const matchStockLotRoute = (pathname: string): ContinuationTarget | null => {
	const match = /^\/fulfill\/inventory\/lots\/([^/?#]+)$/.exec(pathname);
	if (!match) return null;
	try {
		return { targetId: decodeURIComponent(match[1]), targetKind: STOCK_LOT_TARGET_KIND };
	} catch {
		return null;
	}
};

const stockLotReceiverIdentity: ReceiverIdentityAdapter = {
	buildCleanPath: ({ targetId }) => (targetId ? `/fulfill/inventory/lots/${encodeURIComponent(targetId)}` : ""),
	matchesRoute: matchStockLotRoute
};

export default stockLotReceiverIdentity;
